import React from 'react';
import ReactDOM from 'react-dom';

let ymapsModules: any = null;

export const initializeYandexMaps = async () => {
  if (ymapsModules && window.ymaps3) {
    return ymapsModules;
  }

  if (!window.ymaps3) {
    ymapsModules = null;
    throw new Error('Yandex Maps API (ymaps3) is not loaded yet');
  }

  try {
    const [ymaps3React, ymaps3DefaultUI] = await Promise.all([
      window.ymaps3.import('@yandex/ymaps3-reactify'),
      window.ymaps3.import('@yandex/ymaps3-default-ui-theme'),
    ]);

    const reactify = ymaps3React.reactify.bindTo(React, ReactDOM);

    ymapsModules = {
      reactify,
      YMap: reactify.module(window.ymaps3).YMap,
      YMapDefaultSchemeLayer: reactify.module(window.ymaps3).YMapDefaultSchemeLayer,
      YMapDefaultFeaturesLayer: reactify.module(window.ymaps3).YMapDefaultFeaturesLayer,
      YMapMarker: reactify.module(window.ymaps3).YMapMarker,
      YMapControls: reactify.module(window.ymaps3).YMapControls,
      YMapControlButton: reactify.module(window.ymaps3).YMapControlButton,
      YMapZoomControl: reactify.module(ymaps3DefaultUI).YMapZoomControl,
    };

    return ymapsModules;
  } catch (error) {
    console.error('Failed to initialize Yandex Maps:', error);
    ymapsModules = null;
    throw error;
  }
};

export const cleanupYandexMaps = () => {
  ymapsModules = null;
};

export const reactify = ymapsModules?.reactify;
export const YMap = ymapsModules?.YMap;
export const YMapDefaultSchemeLayer = ymapsModules?.YMapDefaultSchemeLayer;
export const YMapDefaultFeaturesLayer = ymapsModules?.YMapDefaultFeaturesLayer;
export const YMapMarker = ymapsModules?.YMapMarker;
export const YMapControls = ymapsModules?.YMapControls;
export const YMapZoomControl = ymapsModules?.YMapZoomControl;
export const YMapControlButton = ymapsModules?.YMapControlButton;